import { render } from "./HeroiconsSolidBan.vue?vue&type=template&id=182a0047"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidBan.vue"]])

export default __exports__